import { Component, DestroyRef, inject, Input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { NotificationService } from "@dmms/core/notification";
import { DictionaryService } from "@dmms/core/http";
import { AdministrationEndpoints } from "@app/shared/data-access/src/lib/administration/types/administration-endpoints";
import { HardStringUtils } from "@hardcode-kz/ui";
import { catchError, of } from "rxjs";
import { IBpUser } from "@models/user-management/user";
import { HttpErrorResponse } from "@angular/common/http";
import { ApiErrorFieldEnum } from "@models/http/http-options";

@Component({
  selector: "bp-user-toggle",
  standalone: true,
  imports: [MatSlideToggleModule],
  template: `
    <mat-slide-toggle
      [checked]="item.isActive"
      (change)="toggle()"
    ></mat-slide-toggle>
  `,
})
export class BpUserToggleComponent {
  @Input() item: IBpUser;

  private readonly dicService = inject(DictionaryService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly notificationService = inject(NotificationService);

  toggle(): void {
    const previousState = this.item.isActive;
    this.item.isActive = !this.item.isActive;

    const endpoint = `v1/${HardStringUtils.getUrl(
      previousState
        ? AdministrationEndpoints.BpUserInactivate
        : AdministrationEndpoints.BpUserActivate,
      { id: this.item.id },
    )}`;

    this.dicService
      .put(endpoint, {})
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        catchError((err: HttpErrorResponse) => {
          this.item.isActive = previousState;
          this.notificationService.findAndShowErrors(
            err,
            ApiErrorFieldEnum.Code,
          );
          return of(null);
        }),
      )
      .subscribe();
  }
}
